import React from 'react';
import type { ProjectCardProps } from '../projects.types';
import './ProjectCard.styles.css';

/**
 * Grid project preview card.
 * Triggers 3D hover overlays, canvas background blur, and master-detail expansion.
 */
export const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  isVisible,
  onSelect,
  onHoverChange,
}) => {
  return (
    <article
      role="button"
      tabIndex={0}
      className={`project-card ${isVisible ? 'visible' : ''}`}
      onClick={() => onSelect(project)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(project);
        }
      }}
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
      aria-label={`Select ${project.title} for expanded presentation`}
    >
      <div className="card-top-meta">
        <span className="card-category-pill">{project.category}</span>
        {project.professional && (
          <span className="card-badge professional">Professional</span>
        )}
        {project.featured && !project.professional && (
          <span className="card-badge featured">Featured</span>
        )}
      </div>

      <h3 className="project-card-title">{project.title}</h3>

      {project.role && (
        <div className="project-card-role">
          <i className="fas fa-layer-group" />
          <span>{project.role}</span>
        </div>
      )}

      <p className="project-card-desc">{project.description}</p>

      {/* * Technologies tagged with bracket syntax: [ <tag> ] */}
      <div className="card-tech-group">
        {project.tech.slice(0, 4).map((tech, idx) => (
          <span key={idx} className="card-bracket-tag">
            <span className="card-bracket-symbol">[</span>
            <span>{tech}</span>
            <span className="card-bracket-symbol">]</span>
          </span>
        ))}
      </div>

      <div className="card-footer-cta">
        <span>View Details</span>
        <i className="fas fa-arrow-right" />
      </div>
    </article>
  );
};

export default ProjectCard;
